export default __webpack_public_path__ + "static/front-5957c16eface329778294d8fb75614b2.jpg";